module.exports = "<div class=row><div class=\"list-view col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8\"><mysharelist></mysharelist></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/myshare-view.vue
// module id = 91
// module chunks = 0